import { compose, createStore, applyMiddleware } from 'redux';
import Thunk from 'redux-thunk';
import reducer from './common/modules';
import { actions } from './common/modules';

import Utils from './common/Utils';
import { getReencodedUriParams, getUriCombinedParams, setCookie } from './common/util';

import Navi from './Navi';
import PreLoader from './common/PreLoader';

import SecGate from './section/SecGate';
import SecBanquet from './section/SecBanquet';
import SecLivingroom from './section/SecLivingroom';
import SecPassage from './section/SecPassage';
import SecGarden from './section/SecGarden';
import LayerInit from './LayerInit';

import ShareExtend from './common/ShareExtend';

class App {
    constructor(_config = {}) {
        console.log('---------------------------- App start ----------------------------');

        const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
        this.store = createStore(reducer, composeEnhancers(applyMiddleware(Thunk)));
        this.store.dispatch(actions.setConfig(_config));

        this.navi = new Navi('navi', this.store, '.aside');
        this.layer = new LayerInit();

        this.sections = {
            gate: new SecGate(this.store, '.section-gate'),
            banquet: new SecBanquet(this.store, '.section-banquet'),
            livingroom: new SecLivingroom(this.store, '.section-livingroom'),
            passage: new SecPassage(this.store, '.section-passage'),
            garden: new SecGarden(this.store, '.section-garden'),
        }

        // const sectionCheckData = JSON.parse(localStorage.getItem('linm3rd_sectionchecklist'));
        // this.store.dispatch(actions.setSecCookies(sectionCheckData || this.store.getState().secCookies));
        this.store.dispatch(actions.setSecCookies({
            gate: true,
            banquetIntro: true,
            banquetKeynote: true,
            livingroom: true,
            passage: true,
            garden: true,
        }));

        const stampData = JSON.parse(localStorage.getItem('linm3rd_stamplist'));
        this.store.dispatch(actions.setStamp(stampData || this.store.getState().stamp));

        this.addEvents();

        this.layer.dirLayerOpen('#' + Utils.getParamByName('dirlayer'));

        new PreLoader(_config.staticPath, () => this.sections['gate'].start());
    }

    addEvents() {
        $('#container').on('sec.end', (e, oldName, newName) => this.sections[newName].start());

        // layer 신서버&신규클래스
        const updateBanner = $('#layer-newUpdate');
        if (updateBanner.length > 0) {
            $('#layer-newUpdate').fadeIn();
            $('#layer-newUpdate').on('click', '.layer-btn-close, .dimmed', () => {
                $('#layer-newUpdate').fadeOut();
            });
        }

        // share
        $('.share-open').on('click', () => {
            $('#share').fadeIn();
        });

        $('.share').on('click', '.share-close, .share-dimmed', () => {
            $('#share').fadeOut();
        });

        // setHome
        $('.save-cookie').on('click', function (event) {
            event.preventDefault();
            setCookie('LineageM_WEB_VISIT_200624', false, 1000);
            location.href = '/';
        });

        // addTracking
        const $goPreorderBtn = $('#nav-controller .go-preorder');
        const params = getReencodedUriParams(location.href) || {};
        const url = getUriCombinedParams($goPreorderBtn.attr('href') || '', params);
        $goPreorderBtn.attr('href', url);

        // mobile button hide
        if (this.store.getState().config.device === 'mobile') {
            $('body').on('click', e => {
                if (!$(e.target).hasClass('btn-spot') && !$(e.target).hasClass('btn-spot-layer')) {
                    $('.btn-spot-layer').hide();
                }
            });
        }

    }

}

Utils.namespace('nc.linm.trinity');
nc.linm.trinity = App;